import { APIService } from '@services/api/common-services';
import { UseMutateFunction, useMutation } from '@tanstack/react-query';
import { UpdateSiteVisitStatusData } from '.';
import { APPCONFIG } from '@config/app.config';

interface IUpdateSiteVisitData {
	mutate: UseMutateFunction<UpdateSiteVisitStatusData, Error, UpdateSiteVisitStatusData, unknown>;
	error: Error | null;
	isPending: boolean;
	isError: boolean;
}

export const useUpdateSiteVisitStatusMutation = (): IUpdateSiteVisitData => {
	const patchSiteVisitData = async (
		siteLeadFormData: UpdateSiteVisitStatusData
	): Promise<UpdateSiteVisitStatusData> => {
		const url = `${APPCONFIG.baseUrl}${APPCONFIG.apiVersion}/site-leads/wwa/visit/${siteLeadFormData?.siteVisitId}/update-status/`;
		return await APIService.patchData<UpdateSiteVisitStatusData>(url, {
			status: siteLeadFormData.status,
			contractor_latitude_c: siteLeadFormData.contractor_latitude_c ?? null,
			contractor_longitude_c: siteLeadFormData.contractor_longitude_c ?? null,
		});
	};

	const { mutate, error, isError, isPending } = useMutation({
		mutationFn: patchSiteVisitData,
	});

	return {
		mutate,
		error,
		isError,
		isPending,
	};
};
